export const dateLongFormat = 'D/MM/YYYY HH[h]mm';
